// test2342
(2342 && 0);
